import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-7ac804eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer uploadExcelModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = { class: "col-sm-4" }
const _hoisted_11 = { class: "col-sm-4" }
const _hoisted_12 = { class: "col-sm-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-5" }, null, -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = { class: "col-sm-4" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = {
  key: 0,
  class: "text-center mt-5"
}
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isReadOnly)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              localizedKey: "Premises detail",
              text: "Premises detail"
            }))
          : (_openBlock(), _createBlock(_component_localized_text, {
              key: 1,
              localizedKey: "Add premises",
              text: "Add premises"
            }))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_form_field, {
              type: "text",
              modelValue: _ctx.localPremisesType.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localPremisesType.name) = $event)),
              labelKey: "Premises type",
              labelValue: "Premises type",
              readonly: _ctx.isReadOnly
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_field, {
              type: "text",
              modelValue: _ctx.localPremisesType.address,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localPremisesType.address) = $event)),
              labelKey: "Location",
              labelValue: "Location",
              readonly: _ctx.isReadOnly
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_form_field, {
              type: "number",
              modelValue: _ctx.localPremisesType.squareMeters,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localPremisesType.squareMeters) = $event)),
              labelKey: "Area m2",
              labelValue: "Area m2",
              readonly: _ctx.isReadOnly
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_form_field, {
              type: "number",
              modelValue: _ctx.localPremisesType.headCounts,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localPremisesType.headCounts) = $event)),
              labelKey: "Headcounts",
              labelValue: "Headcounts",
              readonly: _ctx.isReadOnly
            }, null, 8, ["modelValue", "readonly"])
          ])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_form_field, {
              type: "number",
              modelValue: _ctx.localPremisesType.operationalApproachPercentage,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localPremisesType.operationalApproachPercentage) = $event)),
              labelKey: "Operational approach (%)",
              labelValue: "Operational approach (%)",
              readonly: _ctx.isReadOnly
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_form_field, {
              type: "number",
              modelValue: _ctx.localPremisesType.financialControlPercentage,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localPremisesType.financialControlPercentage) = $event)),
              labelKey: "Financial control (%)",
              labelValue: "Financial control (%)",
              readonly: _ctx.isReadOnly
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_form_field, {
              type: "number",
              modelValue: _ctx.localPremisesType.equitySharePercentage,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localPremisesType.equitySharePercentage) = $event)),
              labelKey: "Equity share (%)",
              labelValue: "Equity share (%)",
              readonly: _ctx.isReadOnly
            }, null, 8, ["modelValue", "readonly"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_form_field, {
              type: "textarea",
              modelValue: _ctx.localPremisesType.notes,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localPremisesType.notes) = $event)),
              labelKey: "Comment",
              labelValue: "Comment",
              readonly: _ctx.isReadOnly
            }, null, 8, ["modelValue", "readonly"])
          ])
        ])
      ]),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-tertiary",
              disabled: !_ctx.localPremisesType.name,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.savePremises()))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Save",
                text: "Save"
              })
            ], 8, _hoisted_21)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}